<template>  
  <format
    :msg="$t('online-football')"
    :type-game="3"
    :src="require('@/assets/nav/submenu/icon_submenu16.svg')"
  > 
    <v-row 
      no-gutters 
      class="toolbartab  pa-3 " 
    > 
      <h5>
        <mark class="red--text">
          *** {{ $t('desc.external-game-football-detail') }}
        </mark>
      </h5> 
    </v-row>  
  </format>
</template>
<script>  
import format from './childs/format'

export default {

  components : {
    format
  },   
} 
</script> 